import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'
import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import getError from '@/containers/SubscriptionFormPageNew/getError'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'

const Zipcode = () => {
  const { t, updateAddress, errors, zipcode } = useAddress()

  return (
    <SDFormControl plainLabel error={getError('zipcode', errors)}>
      <SDInput
        label={t('subscriptionForm:address_module.zipcode')}
        onBlur={zipcode => updateAddress({ zipcode })}
        currentValue={zipcode}
      />
    </SDFormControl>
  )
}

export default Zipcode
